export default "__VITE_ASSET__Ay5NfYFT__"